import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Check from '../../../assets/icons/check.svg';

import './ourServiceSection.scss';

export default function OurServiceSection(props) {
  const { pretitle, title, subtitle } = props;

  return (
    <section id="our-service" className="our-service">
      <div className="title-container">
        <p className="overline salmon">{pretitle}</p>
        <h2>{parse(title)}</h2>
        <h6>{subtitle}</h6>
      </div>
      <div className="content">
        <div className="visio">
          <StaticImage src="../../../images/index/home_care_ipad.png" alt="" className="ipad" />
          <StaticImage src="../../../images/index/home_care_shine.png" alt="" className="shine" />
          <StaticImage src="../../../images/index/home_care_iphone.png" alt="" className="iphone" />
          <StaticImage src="../../../images/index/home_care_shipment.png" alt="" className="shipment" />
          <StaticImage src="../../../images/index/home_care_tasks.png" alt="" className="tasks" />
          <StaticImage
            src="../../../images/index/home_care_notification.png"
            alt=""
            className="notifications"
          />
        </div>

        <div className="description">
          <div>
            <Check />
            <h6>
              <span className="bold">Video consultations</span>
              <br />
              So you can skip the&nbsp;trip
              <br />
              {' '}
              to&nbsp;the&nbsp;clinic.
            </h6>
          </div>
          <div>
            <Check />
            <h6>
              <span className="bold">Licensed providers</span>
              <br />
              Dedicated to improving
              <br />
              {' '}
              your&nbsp;sleep for&nbsp;good.
            </h6>
          </div>
          <div>
            <Check />
            <h6>
              <span className="bold">A sleep study</span>
              <br />
              From the comfort
              <br />
              {' '}
              of&nbsp;your own&nbsp;bed.
            </h6>
          </div>
        </div>
      </div>
    </section>
  );
}

OurServiceSection.propTypes = {
  pretitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
